import { useQuery, useMutation } from "@tanstack/react-query";

import logger from "../../../../logger";

export const userKeys = {
  all: ["users"],
  lists: () => [...userKeys.all, "list"],
  list: (filters) => [...userKeys.lists(), { filters }],
  items: () => [...userKeys.all, "item"],
  item: (id) => [...userKeys.items(), id],
};

export function useUser(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: userKeys.item(args.id),
    queryFn: () => func(args.id),
    ...queryOptions,
  });
}

export function useUserByEmail(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: userKeys.item(args.id),
    queryFn: () => func(args.id),
    ...queryOptions,
  });
}

export function useUsers(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: userKeys.list(args.filters),
    queryFn: () => func(args.filters),
    ...queryOptions,
  });
}

export function useUpdateUser(func, callbacks = {}) {
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
      callbacks.onError && callbacks.onError(error);
    },
    onSuccess: (data, variables, context) => {
      callbacks.onSuccess && callbacks.onSuccess(data, variables, context);
    },
    onSettled: () => {
      callbacks.onSettled && callbacks.onSettled();
    },
  });
}
